<template>
  <div></div>
</template>

<script>
import api from "../assets/js/api.js";
import wxapi from "../assets/js/wxapi";
import util from "../assets/js/util";
var that;
export default {
  data() {
    return {
      flag: 0, //0店员，1:用户
      firstCome: 1
    };
  },
  created() {
    that = this;
    if(that.firstCome === 1) {
      util.clearss();
    }
  },
  mounted() {
    that.$nextTick(function() {
      var url = location.search;
      let urls = that.getRequest();
      let user_type = urls.url_type;
      util.setss("userType", urls.url_type);
      if(that.firstCome == 2) {
         //这个可以关闭安卓系统的手机
        document.addEventListener('WeixinJSBridgeReady', function() {
            WeixinJSBridge.call('closeWindow');
        }, false);
        //这个可以关闭ios系统的手机
        WeixinJSBridge.call('closeWindow');
        return;
      }
      that.firstCome = 2;

      if (urls.code == null || urls.code == undefined || urls.code == "") {
        let protocol = window.location.protocol;
        let host = window.location.host;
        window.location.replace(
          `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${urls.appId}&redirect_uri=${protocol}//${host}?url_type=${urls.url_type}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`
        );
        return;
      }
      
      if (user_type == 0) {
        that.$http
          .get(api.getClerkOpenId, {
            params: {
              code: urls.code
            }
          })
          .then(res => {
            if (res.code === util.ERR_OK) {
              util.setss("openId", res.data.openId);
              if (res.data.type) {
                util.setss("token", res.data.token);
                util.setss("clerkMsg", JSON.stringify(res.data.apiClerk));
                that.$router.replace({ path: "/scan" });
              } else {
                that.$router.replace({ path: "/login" });
              }
            } else {
              that.$toast({ message: res.msg, duration: 2000 });
            }
          });
      } else if (user_type == 1) {
        that.$http
          .get(api.getUserOpenId, {
            params: {
              code: urls.code
            }
          })
          .then(res => {
            if (res.code === util.ERR_OK) {
             
              if (res.data.type) {
                util.setss("token", res.data.token);
                util.setss("memberMsg", JSON.stringify(res.data.apiMember));
                that.$router.replace({ path: "/coupon" });
              } else {
                util.setss("openId", res.data.openId);
                that.$router.replace({ path: "/register" });
              }
            } else {
              that.$toast({ message: res.msg, duration: 2000 });
            }
          });
      }
    });
  },
  methods: {
    getRequest() {
      var url = location.search; //获取url中"?"符后的字符串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        let strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped></style>
